/* eslint-env browser */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './prod';

ReactDOM.render(<App />, document.getElementById('au_timeline'));
